import { authExchange } from "@urql/exchange-auth";

export const cognitoAuthExchange = authExchange(async (utils) => {
  return {
    addAuthToOperation: (operation) => {
      const token = getIdToken();
      if (!token) return operation;
      return utils.appendHeaders(operation, {
        Authorization: token,
      });
    },
    didAuthError(error) {
      return (
        error.graphQLErrors[0].message === "Unauthorized" ||
        error.graphQLErrors[0].message === "管理者ではありません" ||
        error.graphQLErrors[0].message === "普通ユーザではありません"
      );
    },
    refreshAuth: async () => {},
  };
});

export const getIdToken = (): string | undefined => {
  const token = localStorage.getItem("jwt_token");
  if (!token) return undefined;
  return token;
};
